"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    rpc: {},
    types: {
        StatementKind: {
            _enum: ['Regular', 'Saft']
        }
    }
};
